export const fifteenMins = 15;
export const hoursInDay = 24;
export const minsInHour = 60;
export const minsInSecond = 60;
export const msInSecond = 1000;

export const US_DATE_FORMAT = 'MM/dd/yyyy';
export const US_LONG_DATE_FORMAT = 'EEEE, MMMM dd, y';
export const LOCALIZED_MONTH_DAY_YEAR_FORMAT = 'MMMM do yyyy';
